import { useRoutes } from "react-router-dom";
import LoginPage from "../pages/main/Login";
import MainPage from "../pages/main/MainPage";
import HostRegistryList from "../pages/hostRegistry/HostRegistryList";
import MainHostRegistry from "../pages/hostRegistry/MainHostRegistry";
import MainPageUser from "../pages/users/MainUserPage";
import NewUserPage from "../pages/users/NewUserPage";
import UsersListPage from "../pages/users/UsersList";
import PrivateGuard from "./guard/PrivateGuard";
import PublicGuard from "./guard/PublicGuard";
import HostRegistryNewPage from "../pages/hostRegistry/HostRegistryNewPage";
import CallsListPage from "../pages/calls/CallsListPage";
import InterviewListPage from "../pages/interview/InterviewListPage";
import HomePage from "../pages/HomePage";
import RoleGuard from "./guard/RoleGuard";
import { AllRole, ListInterviewRole, SuperAdminVisore, SuperAdminVisoreOpe, SuperAdminVisoreOpeCons, SuperAndAdmin, SuperAndAdvance } from "../utils/genericList/ListRoleRoutes";
import ReportPage from "../pages/report/ReportPage";
import ProductsPage from "../pages/products/ProductsPage";
import AgencyList from "../pages/agency/AgencyList";
import MainPageAgency from "../pages/agency/MainPageAgency";
import AgencyActionsPage from "../pages/agency/AgencyActionsPage";
import PrivacyPage from "../pages/main/PrivacyPage";
import { PrivacyGuard, PrivacyGuardOnPage } from "./guard/PrivacyGuard";
import MainCalendar from "../pages/calendar/mainCalendar";
import AppointmentsCalendarUsers from "../pages/calendar/AppointmentsCalendarUsers";

export default function RoutesList() {

    return useRoutes([
        {
            path: '/',
            element: <PublicGuard>
                <LoginPage />
            </PublicGuard>
        },
        {
            path: 'privacy',
            element: <PrivacyGuardOnPage>
                <PrivacyPage documentiAziendali={undefined} />
            </PrivacyGuardOnPage>
        },
        {
            path: '/dashboard',
            element:
                <PrivacyGuard>
                    <PrivateGuard>
                        <MainPage />
                    </PrivateGuard>
                </PrivacyGuard>,
            children: [
                {
                    path: '/dashboard/home',
                    element: <HomePage />
                },
                {
                path: 'appointments-days',
                    element: <RoleGuard visabilityRole={AllRole}>
                        <AppointmentsCalendarUsers />
                    </RoleGuard>,
                },
                {
                    path: 'appointments',
                    element: <RoleGuard visabilityRole={SuperAndAdvance}>
                        <MainCalendar />
                    </RoleGuard>,
                },
                {
                    path: 'agency',
                    element: <RoleGuard visabilityRole={SuperAndAdvance}>
                       <MainPageAgency />
                    </RoleGuard>,
                    children: [
                        {
                            path: '/dashboard/agency',
                            element: <AgencyList />
                        },
                        {
                            path: 'update/:id',
                            element: <AgencyActionsPage />
                        },
                    ]
                },
                {
                    path: 'users',
                    element: <RoleGuard visabilityRole={SuperAdminVisore}>
                        <MainPageUser />
                    </RoleGuard>,
                    children: [
                        {
                            path: '/dashboard/users',
                            element: <UsersListPage />
                        },
                        {
                            path: 'new-user',
                            element: <NewUserPage />
                        }
                    ]
                },
                {
                    path: 'host-registry',
                    element: <RoleGuard visabilityRole={SuperAdminVisoreOpeCons}>
                        <MainHostRegistry />
                    </RoleGuard>,
                    children: [
                        {
                            path: '/dashboard/host-registry',
                            element: <HostRegistryList />
                        },
                        {
                            path: 'new',
                            element: <HostRegistryNewPage />
                        } 
                    ]
                },
                {
                    path: 'calls',
                    element: <RoleGuard visabilityRole={SuperAdminVisoreOpe}>
                        <CallsListPage />
                    </RoleGuard>,
                },
                {
                    path: 'interviews',
                    element: <RoleGuard visabilityRole={ListInterviewRole}>
                        <InterviewListPage />
                    </RoleGuard>,
                },
                {
                    path: 'reports',
                    element:  <RoleGuard visabilityRole={[...SuperAdminVisore, "Consulente"]}>
                        <ReportPage />
                    </RoleGuard>,
                },
                {
                    path: 'products',
                    element: <RoleGuard visabilityRole={SuperAndAdmin}>
                        <ProductsPage />
                    </RoleGuard>,
                }
            ]
        },
    ])
};